import { useEffect, useRef } from "react";
import { io, Socket } from "socket.io-client";
import { useAuthStore } from "@/store/authStore";
import { toast } from "sonner";

const rawUrl = import.meta.env.VITE_API_URL?.replace("/api", "") || "";
const SOCKET_URL = rawUrl && rawUrl !== "" ? rawUrl : "http://localhost:4000";

export const useSocket = () => {
  const socketRef = useRef<Socket | null>(null);
  const user = useAuthStore((s) => s.user);

  useEffect(() => {
    if (!user) return;

    // Initialize socket connection
    const socket = io(SOCKET_URL);
    socketRef.current = socket;

    socket.on("connect", () => {
      console.log("🟢 Connected to Socket.io");
      socket.emit("join", user.id);
    });

    socket.on("connect_error", (error) => {
      console.error("🔴 Socket connection error:", error);
    });

    return () => {
      socket.disconnect();
    };
  }, [user]);

  const on = (event: string, callback: (data: any) => void) => {
    if (socketRef.current) {
      socketRef.current.on(event, callback);
    }
  };

  const off = (event: string) => {
    if (socketRef.current) {
      socketRef.current.off(event);
    }
  };

  return { on, off, socket: socketRef.current };
};
